var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"hp-bloglist__article"},[(_vm.index === 0)?_c('div',{staticClass:"image-container image-container--2x1 image-container--1x1-mobile mobile-full-width"},[_c('img')]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"hp-bloglist__title"},[_c('dot-dot-dot',{attrs:{"associated-action":"getSectionFeaturedArticles"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }